// extracted by mini-css-extract-plugin
export default {"menu":"O9Ll5","item":"aQfL4","active":"HfCfi","panel":"MminK","badge":"CZaME"};